/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {inject, Injectable} from '@angular/core';
import {AbstractResourceService, JsonApiResource} from '@irian-ro/abstract-resource';
import {EnvironmentService} from "@irian-ro/util-environment";
import { HttpClient } from '@angular/common/http';
import {SelectItemsManagementModel} from './select-items-management.model';
import {map, switchMap, take} from "rxjs/operators";
import {Observable} from "rxjs";
import { SelectItemsVoModel } from "@well/common-libs/select-items/domain";
import { LoggedInContextService } from "@well/shared-providers";

@Injectable({
  providedIn: 'root'
})
export class SelectItemsResourceService extends AbstractResourceService<SelectItemsVoModel,
  SelectItemsManagementModel,
  any,
  any> {
  private contextService = inject(LoggedInContextService);

  constructor(httpClient: HttpClient,
              private environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('selectItemsUrl'),
      SelectItemsVoModel,
      SelectItemsManagementModel
    );
  }

  getSelectItemsByField(field?: any): Observable<JsonApiResource<SelectItemsVoModel[], any>> {
    return this.contextService.userContext$.pipe(
        take(1),
        map(res => {
          if (res) {
            return {
              filters: {
                fieldName: {
                  value: field,
                  matchMode: 'equals'
                },
                locale: {
                  value: res.loggedInUser?.language,
                  matchMode: 'equals'
                }
              }
            }
          } else {
            return {
              filters: {
                fieldName: {
                  value: field,
                  matchMode: 'equals'
                }
              }
            };
          }
        }),
        switchMap(query => this.findAll(query))
      );
  }
}

